'use strict';

(function () {
  'use strict';

  angular.module('msProviderConnect').component('msLibraryFiles', {
    templateUrl: 'providerconnect/templates/library-files.html',
    controller: LibraryFilesCtrl,
    controllerAs: 'vm',
    bindings: {
      categories: '<',
      // true or false, depending on whether categories are inclusive or exclusive
      inclusive: '<'
    }
  });
  LibraryFilesCtrl.$inject = ['providerLibrarySvc'];

  function LibraryFilesCtrl(providerLibrarySvc) {
    var vm = this;
    vm.$onInit = function () {
      activate();
    };

    function activate() {
      providerLibrarySvc.getFiles().then(function (categories) {
        if (_.isArray(vm.categories)) {
          vm.categories = categories.filter(function (cat) {
            return vm.inclusive ? _.includes(vm.categories, cat.categoryName) : !_.includes(vm.categories, cat.categoryName);
          });
        } else {
          vm.categories = categories;
        }
      });
    }
  }
})();